import React, {useEffect, useState} from "react";
import {
    Input,
    RangeInputField,
    RangeInputLabel,
    RangeInputFieldWrapper,
    NumberInput,
    MinMaxValue,
} from "./widgets/Styled";
import {FieldInputProps} from "react-final-form";
import {ErrorHelperText} from "../HTMLEntities/Textfield/widgets/Styled";
import {StepSchema} from "../../containers/RegistrationLoginPage/types";
import ToolTip from "../HTMLEntities/ToolTip";

type RangeInputSelectedValue = number | null | undefined;

interface RangeInputInterface {
    heading?: string;
    fieldName?: string;
    subheading?: string;
    toolTip?: string;
    isFocused?: boolean;
    isError?: boolean | string;
    isTouched?: boolean;
    initialValue: RangeInputSelectedValue;
    inputRFF?: FieldInputProps<RangeInputSelectedValue>;
    editable: boolean;
    values: StepSchema | null;
    type?: "Percentage" | null;
    displayOnlySlider?: boolean;
    onChange?(event?: React.ChangeEvent<HTMLInputElement>): void;
    rangeInputStyle?: {
        mobile: {width: string};
        laptop: {width: string};
    };
    label?: {
        min: string;
        max: string;
    };
}
const defaultProps = {
    rangeInputStyle: {
        mobile: {width: "76%"},
        laptop: {width: "76%"},
    },
};
const RangeInput: React.FC<RangeInputInterface> = ({
    heading,
    fieldName,
    subheading,
    toolTip,
    isFocused = false,
    isError = false,
    isTouched = false,
    initialValue,
    inputRFF,
    editable,
    values,
    type = null,
    displayOnlySlider = false,
    onChange,
    rangeInputStyle = defaultProps.rangeInputStyle,
    label,
}: RangeInputInterface) => {
    const [value, setValue] = useState(inputRFF ? undefined : initialValue);
    const error = isError && isTouched;
    const defaultState = initialValue?.toString() ? false : true;

    useEffect(() => {
        if (!inputRFF) {
            setValue(initialValue);
        }
    }, [inputRFF, initialValue]);

    return (
        <RangeInputFieldWrapper>
            {values && (
                <>
                    <RangeInputField rangeInputStyle={rangeInputStyle}>
                        {!displayOnlySlider && (
                            <RangeInputLabel>
                                {heading}
                                {subheading && <span>{subheading}</span>}
                                {toolTip && (
                                    <ToolTip
                                        tooltipLabel={toolTip}
                                        id={`${fieldName ?? ""}toolTip`}
                                        ToolTipStyle={{
                                            mobile: {bottom: "64px"},
                                            laptop: {bottom: "26px"},
                                        }}
                                    />
                                )}
                            </RangeInputLabel>
                        )}
                        <Input
                            type="range"
                            value={value ?? values.min}
                            disabled={!editable}
                            defaultState={defaultState}
                            {...(!inputRFF
                                ? {
                                      // onFocus: () => {},
                                      onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
                                          if (onChange) {
                                              onChange(event);
                                          }

                                          setValue(Number(event.target.value));
                                      },
                                      // onBlur: () => {},
                                  }
                                : inputRFF)}
                            isError={error}
                            min={values.min ?? 0}
                            max={values.max ?? 100}
                            step={values.step ?? 1}
                            {...inputRFF}
                            tabIndex={-1}
                        />
                        <MinMaxValue>
                            <span>
                                {label?.min ? label.min : values.min ?? 0}
                                {label?.min ? "" : type ? "%" : ""}
                            </span>
                            <span>
                                {label?.max ? label?.max : values.max ?? 100}
                                {label?.max ? "" : type ? "%" : ""}
                            </span>
                        </MinMaxValue>
                    </RangeInputField>
                    {!displayOnlySlider && (
                        <NumberInput
                            type="number"
                            placeholder="-"
                            value={value}
                            isError={error}
                            {...(!inputRFF
                                ? {
                                      // onFocus: () => {},
                                      onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
                                          if (onChange) {
                                              onChange(event);
                                          }
                                          setValue(parseInt(event.target.value));
                                      },
                                      // onBlur: () => {},
                                  }
                                : {})}
                            disabled={!editable}
                            min={values.min ?? 0}
                            max={values.max ?? 100}
                            step={values.step ?? 1}
                            {...inputRFF}
                        />
                    )}
                </>
            )}
            {isFocused && error && <ErrorHelperText>{isError}</ErrorHelperText>}
        </RangeInputFieldWrapper>
    );
};
RangeInput.defaultProps = defaultProps;
export default RangeInput;
